import React from 'react';
import { Shield, CheckCircle, Plus } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const handleCTAClick = () => {
    window.open('https://sistema.benmais.com/auto-contratacao?ref=MWZkYjg4ZDEtYzdiOC00ZTZiLWEzZDAtMGE5YjlkMjQ5ZTBhOmJiOGZmOTBiLWM5NjYtNDVmZi05MzAwLTUwNTkwMzhjYTczMQ==', '_blank');
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-cyan-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-[#00E5CC]/10 text-[#0A1E2E] px-4 py-2 rounded-full text-sm font-bold border-2 border-[#00E5CC]/20">
              <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
              Proteção Completa para Toda Família
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-[#0A1E2E] leading-tight">
              Segurança e Bem-Estar por Apenas{' '}
              <span className="text-[#00E5CC]">R$ 59,90/mês</span>
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Tenha acesso a telemedicina 24h, descontos em farmácias, assistência residencial, 
              indenizações e muito mais. Proteção completa para você e até 4 dependentes.
            </p>

            <div className="space-y-3">
              {[
                'Telemedicina 24 horas',
                'Descontos de até 70% em farmácias',
                'Indenização por invalidez até R$ 10.000',
                'Indenização por morte até R$ 10.000',
                'Auxílio funeral até R$ 3.000',
                'Descontos em consultas e exames',
                'Assistência residencial emergencial',
                'Assistência jurídica completa'
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Plus className="w-5 h-5 text-[#00E5CC] flex-shrink-0" strokeWidth={3} />
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={handleCTAClick}
                size="lg"
                className="bg-[#00E5CC] hover:bg-[#00D4BE] text-[#0A1E2E] text-lg px-8 py-6 font-bold transition-all duration-300 hover:shadow-xl hover:scale-105"
              >
                <Plus className="w-5 h-5 mr-2" strokeWidth={3} />
                Quero os Benefícios
              </Button>
            </div>

            <p className="text-sm text-gray-500">
              ✓ Ativação imediata após o primeiro pagamento
            </p>
          </div>

          {/* Right Content - Trust Visual */}
          <div className="relative">
            <div className="bg-white rounded-3xl shadow-2xl p-8 space-y-6">
              <div className="flex items-center justify-between border-b border-[#00E5CC]/20 pb-6">
                <span className="text-gray-600 font-medium">Investimento Mensal</span>
                <div className="text-right">
                  <div className="text-4xl font-bold text-[#00E5CC]">R$ 59,90</div>
                  <div className="text-sm text-gray-500">por mês</div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-[#00E5CC]/10 rounded-lg flex items-center justify-center flex-shrink-0 border border-[#00E5CC]/30">
                    <Plus className="w-5 h-5 text-[#00E5CC]" strokeWidth={3} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">8 Benefícios Inclusos</h4>
                    <p className="text-sm text-gray-600">Cobertura completa para sua tranquilidade</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-[#00E5CC]/10 rounded-lg flex items-center justify-center flex-shrink-0 border border-[#00E5CC]/30">
                    <CheckCircle className="w-5 h-5 text-[#00E5CC]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Titular + 4 Dependentes</h4>
                    <p className="text-sm text-gray-600">Proteção para toda a família</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-[#00E5CC]/10 rounded-lg flex items-center justify-center flex-shrink-0 border border-[#00E5CC]/30">
                    <Shield className="w-5 h-5 text-[#00E5CC]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Ativação Imediata</h4>
                    <p className="text-sm text-gray-600">Válido a partir do 1º pagamento</p>
                  </div>
                </div>
              </div>

              <Button
                onClick={handleCTAClick}
                className="w-full bg-[#00E5CC] hover:bg-[#00D4BE] text-[#0A1E2E] font-bold py-6 text-lg transition-all duration-300 hover:shadow-lg"
              >
                Quero os Benefícios
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
